import { API_BASE_URL, getAuthHeaders } from './apiConfig';

const BASE = `${API_BASE_URL}/career-coaches`;

async function parseResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'Request failed');
  }
  return data;
}

export async function fetchCareerCoaches({ activeOnly = false } = {}) {
  const qs = activeOnly ? '?active=1' : '';
  const response = await fetch(`${BASE}${qs}`, { headers: { ...getAuthHeaders() } });
  const data = await parseResponse(response);
  return data.careerCoaches || [];
}

export async function fetchCareerCoachesPublic() {
  const response = await fetch(`${BASE}/public`);
  const data = await parseResponse(response);
  return data.careerCoaches || [];
}

export async function createCareerCoachPublic(name) {
  const response = await fetch(`${BASE}/public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: String(name || '').trim() })
  });
  return parseResponse(response);
}

export async function createCareerCoach(payload) {
  const response = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload)
  });
  return parseResponse(response);
}

export async function updateCareerCoach(id, payload) {
  const response = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload)
  });
  return parseResponse(response);
}

export async function deleteCareerCoach(id) {
  const response = await fetch(`${BASE}/${id}`, {
    method: 'DELETE',
    headers: { ...getAuthHeaders() }
  });
  return parseResponse(response);
}
